import { render, staticRenderFns } from "./deedlookup.vue?vue&type=template&id=a4809074&"
import script from "./deedlookup.vue?vue&type=script&lang=js&"
export * from "./deedlookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports